<div class="alert-content-modal">
    <h2>{{'validations.suspended-service-title'|transloco}}</h2>
    <p>{{'validations.suspended-service-desc'|transloco}}</p>
    <div *ngIf="!sessionOpen" class="btn-alert-center"><button class="btn btn-primary btn-small" (click)="openLink()">{{'label.login-invite'|transloco}}</button></div>
    <div *ngIf="sessionOpen" class="btn-alert-center"><button class="btn btn-primary btn-small" (click)="openLink()">{{'label.dashboard'|transloco}}</button></div>
</div>
